import React from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, ContentfulImage, theme } from '@sg/garnish';

export const ScanToPayFaqEntry = (props: ScanToPayFaqEntryProps) => {
  const { title, image } = props;

  return (
    <View style={styles.container}>
      <ContentfulImage
        style={styles.image}
        baseUrl={image}
        options={{ w: IMAGE_SIZE, h: IMAGE_SIZE, q: 90 }}
      />

      <BodyText sizeMatch={['16']} style={styles.title}>
        {title}
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 32;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
    paddingVertical: theme.spacing['6'],
  },
  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
  },
  title: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayFaqEntryProps = {
  title: string;
  image: string;
};
